<p>{{ 'To enable secure financial operations and comply with regulatory requirements, we need to verify your identity. This one-time verification is required to process online payments, issue spend cards, or use your PayHOA Financial Account. It only takes a couple of minutes!' }}</p>

<h4 dialogSectionHeader>{{ 'What we\'ll need from you:' }}</h4>
<ul dialogList>
    <li>{{ 'Business details, including your HOA\'s legal name, address, and EIN (Employer Identification Number).' }}</li>
    <li>{{ 'Contact information for the primary account holder or authorized representative.' }}</li>
    <li>{{ 'Verification documents, such as a government-issued ID or business registration, to comply with regulatory requirements.' }}</li>
    <li>{{ 'Your consent to the required legal agreements for account and card services.' }}</li>
</ul>

<p>{{ 'By clicking "Start Verification," you\'ll be guided through a secure process to provide this information, activate your PayHOA Financial Account, and review the following agreements:' }}</p>
<ul dialogList>
    <li><a linkButton [href]="stripeUrls.SERVICES_AGREEMENT" target="_blank" rel="noopener">{{ 'Stripe Services Agreement' }}</a></li>
    <li><a linkButton [href]="stripeUrls.CONNECTED_ACCOUNT_AGREEMENT" target="_blank" rel="noopener">{{ 'Stripe Connected Account Agreement' }}</a></li>
    <li><a linkButton [href]="stripeUrls.ISSUING_BANK_TERMS" target="_blank" rel="noopener">{{ 'Issuing Bank Terms (Celtic Bank)' }}</a></li>
</ul>

<div class="actions">
    <button *ngIf="useNewStyles" mat-flat-button color="primary" (click)="onStartVerification()">{{ 'Start Verification' }}</button>

    <!-- legacy button -->
    <app-button *ngIf="!useNewStyles" type="primary" (click)="onStartVerification()">{{ 'Start Verification' }}</app-button>

    <p dialogDisclosureStatement [innerHTML]="disclosureText"></p>
</div>
